// Campus photo for /colleges/pepperdine-university: CC BY-SA 4.0, by Swper, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASmothers_Theater.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/pepperdine-university/; credited under the photo.
const photo = {
    "slug": "pepperdine-university",
    "alt": "Smothers Theatre among palm trees, with hills behind it, on the Pepperdine University campus in Malibu",
    "src": "/colleges/pepperdine-university/campus-1600.webp",
    "srcSmall": "/colleges/pepperdine-university/campus-800.webp",
    "srcMid": "/colleges/pepperdine-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/pepperdine-university/og.jpg",
    "title": "Smothers Theater",
    "author": "Swper",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASmothers_Theater.jpg",
    "read": "2026-10-02"
};

export default photo;
